import { SearchBar } from "@/components/site/SearchBar";

export function SearchSection() {
  return (
    <section
      id="search"
      className="border-b border-[var(--line)] bg-[var(--bg)]"
    >
      <div className="container-wide py-7 md:py-10">
        <div className="mb-3 sm:mb-4">
          <span className="eyebrow">Find Your Property</span>
        </div>
        <SearchBar variant="hero" />
      </div>
    </section>
  );
}
